import React from 'react';

import { BaseIconProps } from './';

export const Star = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(2.1135029,0,0,-2.1135029,9.05e-6,1074.7162)"
    d="M 413,10 255,107 97,11 140,190 0,311 184,325 256,496 327,325 511,310 370,190 Z"
    fill={fill}
  />
);
